import React from 'react';

import {
  Button,
  Grid,
  IconButton
} from '@mui/material';
import {
  Form,
  errorUtil,
  fields,
  formUtil
} from 'iron-forge-react-modules';
import {
  useFieldArray,
  useForm
} from 'react-hook-form';

import { BaseWidget } from 'modules/layer01';
import { DeleteForever } from '@mui/icons-material';
import * as uuid from 'uuid';
import * as dataService from './dataService';
import * as types from './types';



const ControlledTextField = fields.TextField.genControllerComponent<types.IFormState>();



export interface IProps {
  storeId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.storeId);
  const [saveTriageReasons, saveTriageReasonsTuple] = dataService.useSaveTriageReasons(props.storeId);
  const form = useForm<types.IFormState>({
    defaultValues: {
      triageReasons: []
    }
  });
  const fieldArray = useFieldArray<types.IFormState>({
    control: form.control,
    name: 'triageReasons'
  });

  formUtil.useSetFormFields(queryTuple, form.setValue, ['triageReasons']);

  const processSubmit = React.useCallback(
    (formState: types.IFormState) => {
      if (formState.triageReasons.length < 2) {
        alert("Enter at least 2 triage reasons.");
        return;
      }
      errorUtil.errorWrap(async () => {
        await saveTriageReasons(formState);
      }, {
        INVALID_ARGS: "Invalid arguments."
      });
    },
    [saveTriageReasons]
  );

  const loading = queryTuple.loading || saveTriageReasonsTuple.loading;
  return (
    <Form.FC
      disableDefaultOverflow
      onSubmit={form.handleSubmit(processSubmit)}>
      <BaseWidget.FC
        title="Triage Reasons"
        elAction={(
          <Button
            disabled={loading}
            type="submit">
            Save
          </Button>
        )}>
        <Grid container>
          {fieldArray.fields.map((field, index) => (
            <React.Fragment key={field.id}>
              <Grid
                item
                xs={11}>
                <ControlledTextField
                  isDisabled={loading}
                  formControl={form.control}
                  fieldKey={`triageReasons.${index}.reasonText`} />
              </Grid>

              <Grid item xs={1}>
                <IconButton
                  disabled={loading}
                  onClick={() => fieldArray.remove(index)}>
                  <DeleteForever />
                </IconButton>
              </Grid>
            </React.Fragment>
          ))}

          <Grid
            item
            xs={12}>
            <Button
              disabled={loading}
              onClick={() => fieldArray.append({
                id: uuid.v4(),
                reasonText: ''
              })}>
              Add Reason
            </Button>
          </Grid>
        </Grid>
      </BaseWidget.FC>
    </Form.FC>
  );
};
